// Thin wrapper around @simplewebauthn/browser, which handles the actual
// navigator.credentials.create()/get() calls and base64url encoding. We
// never see or store any biometric data here — only the browser/OS
// authenticator does; this just relays the server's challenge and the
// resulting signed assertion.
import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import { api } from '../api/client.js';

/** @param {'tenant-admin' | 'super-admin'} role */
export async function registerPasskey(role, deviceName) {
  const options = await api.post(`/api/${role}/auth/webauthn/register-options`);
  const response = await startRegistration({ optionsJSON: options });
  await api.post(`/api/${role}/auth/webauthn/register-verify`, { response, deviceName });
}

/** @param {'tenant-admin' | 'super-admin'} role */
export async function loginWithPasskey(role) {
  const { options, flowId } = await api.post(`/api/${role}/auth/webauthn/login-options`);
  const response = await startAuthentication({ optionsJSON: options });
  await api.post(`/api/${role}/auth/webauthn/login-verify`, { flowId, response });
}
